import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';


export async function validateToken() {
    const token = localStorage.getItem('token');
    if (!token) return false;

    try {
        const res = await fetch('/api/auth/me', {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (res.ok) {
            return true;
        } else {
            // Token is invalid or expired
            localStorage.removeItem('token');
            return false;
        }
    } catch (err) {
        console.error("Token validation failed:", err);
        localStorage.removeItem('token');
        return false;
    }
};


export function usePermissionGuard(requiredPermission) {
    const [checking, setChecking] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const checkPermissions = async () => {
            const result = await validateToken();
            if (!result) {
                navigate('/admin', {
                    state: { message: 'Bitte logge dich ein.' }
                });
                return;
            }

            const token = localStorage.getItem('token');
            try {
                const res = await fetch('/api/auth/me', {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                });

                if (!res.ok) throw new Error('Unauthorized');
                const data = await res.json();

                if (!data.permissions || !data.permissions.includes(requiredPermission)) {
                    navigate('/admin/panel', {
                        state: { message: 'Du hast keine Berechtigung, diese Seite zu betreten. Wende dich bitte an den Admin!' }
                    });
                } else {
                    setChecking(false);
                }
            } catch (err) {
                console.error("Permission check failed:", err);
                navigate('/admin/panel', {
                    state: { message: 'Fehler bei der Berechtigungsprüfung.' }
                });
            }
        };

        checkPermissions();
    }, [navigate, requiredPermission]);
    return checking;
}

export function useCheckPermission(requiredPermission) {
    const [hasPermission, setHasPermission] = useState(false);
    const [checking, setChecking] = useState(true);

    useEffect(() => {
        const checkPermissions = async () => {
            const result = await validateToken();
            if (!result) {
                setHasPermission(false);
                setChecking(false);
                return;
            }

            const token = localStorage.getItem('token');
            try {
                const res = await fetch('/api/auth/me', {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                });

                if (!res.ok) throw new Error('Unauthorized');
                const data = await res.json();
                const has = data.permissions?.includes(requiredPermission) ?? false;
                setHasPermission(has);
            } catch (err) {
                console.error("Permission check failed:", err);
                setHasPermission(false);
            } finally {
                setChecking(false);
            }
        };

        checkPermissions();
    }, [requiredPermission]);

    return { hasPermission, checking };
}
